module.exports = __webpack_public_path__ + "media/images/add-driver-action-icon-e85ac75f5d8517f1fa57cbcd299a3bc8.svg";